import { helpWithBillingData } from "constants-lib/seo/helpWithBillingData"
import { addJSONLDToHead, removeElement } from "./jsonLD.js"

export const getHelpWithBilling = (schemaData) => {
  const data = schemaData.map((item) => ({
    "@type": `Question`,
    name: item.Question,
    acceptedAnswer: {
      "@type": `Answer`,
      text: item.Answer,
    },
  }))
  return data
}

/* Add Help with Billing JSON LD if needed, otherwise make sure it does not exist in Head. */
export const addHelpWithBilling = () => {
  if (
    window.location.href.includes(
      `/us/en/support/faqs/how-do-i-get-help-with-billing-issues`,
    ) &&
    document.getElementById(`helpWithBilling`) === null
  ) {
    const script = helpWithBillingJSONLD()
    addJSONLDToHead(script, `helpWithBilling`)
  } else {
    removeElement(`helpWithBilling`)
  }
}

// JSON LD template for Help with Billing
const helpWithBillingJSONLD = () => {
  const helpWithBillingTemplate = {
    "@context": `http://schema.org`,
    "@type": `FAQPage`,
    mainEntity: getHelpWithBilling(helpWithBillingData),
  }
  return helpWithBillingTemplate
}
